import SiteLayout from '@/components/feature/SiteLayout';
import HeroArchive from './components/HeroArchive';
import FirmStatement from './components/FirmStatement';
import ExpertiseGrid from './components/ExpertiseGrid';
import ApproachSection from './components/ApproachSection';
import PartnersSection from './components/PartnersSection';
import PerspectivesSection from './components/PerspectivesSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <SiteLayout title="AVENOR | Accounting, Tax & Advisory Firm">
      <HeroArchive />
      <FirmStatement />
      <ExpertiseGrid />
      <ApproachSection />
      <PartnersSection />
      <PerspectivesSection />
      <ContactSection />
    </SiteLayout>
  );
}